import { render, staticRenderFns } from "./Tertiaire.vue?vue&type=template&id=15be0905&"
import script from "./Tertiaire.vue?vue&type=script&lang=js&"
export * from "./Tertiaire.vue?vue&type=script&lang=js&"
import style0 from "./Tertiaire.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports